var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_vm.show ? _c('v-card', [_c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "카테고리",
      "placeholder": " ",
      "hide-details": "",
      "items": _vm.categories,
      "item-text": "name",
      "item-value": "_id"
    },
    on: {
      "change": function change($event) {
        _vm.$data._platform = undefined;
      }
    },
    model: {
      value: _vm.$data._category,
      callback: function callback($$v) {
        _vm.$set(_vm.$data, "_category", $$v);
      },
      expression: "$data._category"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.platforms,
      "item-text": "name",
      "item-value": "_id",
      "label": "플랫폼",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.$data._platform,
      callback: function callback($$v) {
        _vm.$set(_vm.$data, "_platform", $$v);
      },
      expression: "$data._platform"
    }
  })], 1)], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("취소")]), _c('v-btn', {
    attrs: {
      "color": "blue",
      "text": "",
      "disabled": !_vm.$data._platform
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("변경")])], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }